import { toast } from '@/libs/toaster'
export const errorToaster = (key: string, message: string) => {
	// toast.error(`Error in ${key}: ${message}`)
	toast.error(`${message}`)
}

/**
 * Coerce any thrown thing into a safe string for `toast.error(...)`.
 *
 * Why: code historically did `toast.error(error?.message || error || fallback)`.
 * If `error` is a plain object (e.g. raw axios `response.data`), it falls
 * through the `||` chain and toast renders `[object Object]`. This helper
 * walks the common shapes (`.response.data.msg`, `.message`, raw strings,
 * arbitrary objects via JSON.stringify) and ALWAYS returns a string.
 */
export const toErrorMessage = (err: unknown, fallback = 'Error'): string => {
	if (err == null) return fallback
	if (typeof err === 'string') return err
	const e = err as any
	const data = e?.response?.data
	if (typeof data?.msg === 'string') return data.msg
	if (typeof data?.message === 'string') return data.message
	if (typeof data === 'string') return data
	if (data && typeof data === 'object') {
		try { return JSON.stringify(data) } catch { /* circular */ }
	}
	if (typeof e?.message === 'string' && e.message) return e.message
	if (typeof e === 'object') {
		try { return JSON.stringify(e) } catch { /* circular */ }
	}
	return fallback
}
